import { useCallback, useState, useEffect } from 'react';
import { getUserLang, isEuEnv } from '@mb/lib/i18n';
import { CURATED_COLLECTIONS_PAGE } from '../constants';
import { sortedCollectionsType } from '../types';

const userLang = getUserLang();
const prefix = isEuEnv ? `/${userLang}` : '';

export const useCategoryChange = (collections: sortedCollectionsType[]) => {
  const [selectedCategoryId, setSelectedCategoryId] = useState<string | null>(
    null,
  );

  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  const handleCategoryChange = useCallback(
    (categoryId: string | null) => {
      const isSameCategory = categoryId === selectedCategoryId;
      const categoryLabel = isSameCategory
        ? ''
        : collections.find(
            (collection) => collection.category_id === categoryId,
          )?.category_id;
      window.history.pushState(
        {},
        '',
        categoryLabel
          ? `?category=${categoryLabel}`
          : `${prefix}/${CURATED_COLLECTIONS_PAGE}`,
      );
      setSelectedCategoryId(isSameCategory ? null : categoryId);
      scrollToTop();
    },
    [collections, selectedCategoryId],
  );

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const category = urlParams.get('category');
    const categoryId = collections.find(
      (collection) => collection.category_id === category,
    )?.category_id;
    setSelectedCategoryId(categoryId || null);
  }, [collections]);

  useEffect(() => {
    const popstateHandler = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const category = urlParams.get('category');
      const categoryId = collections.find(
        (collection) => collection.category_id === category,
      )?.category_id;
      setSelectedCategoryId(categoryId || null);
    };

    window.addEventListener('popstate', popstateHandler);

    return () => {
      window.removeEventListener('popstate', popstateHandler);
    };
  }, [collections]);

  return { selectedCategoryId, handleCategoryChange };
};
